<template>
    <form action="" class="" v-on:submit.prevent="createBlog">
        <FormErrors :errors="vuelidate.$errors" />
        <InputComponent type="text" placeholder="Nombre" :value="vuelidate.blog.title.$model" v-model="vuelidate.blog.title.$model" />
        <InputComponent type="text" placeholder="Resumen" :value="vuelidate.blog.excerpt.$model" v-model="vuelidate.blog.excerpt.$model" />
        <InputComponent type="textarea" placeholder="Contenido" :value="vuelidate.blog.content.$model" v-model="vuelidate.blog.content.$model" />
        <FileInput v-model="vuelidate.blog.image.$model" accept=".pdf,.jpg,.jpeg,.png" />
        <SubmitButtonComponent value="Guardar"/>
    </form>
</template>

<script>
import { ref } from '@vue/reactivity'
import InputComponent from './InputComponent.vue'
import SubmitButtonComponent from './SubmitButtonComponent.vue'
import FormErrors from './FormErrors.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import useNotification from '../../Services/useNotification'
import FileInput from '../Forms/FileInput.vue'

export default {
    components: {InputComponent,SubmitButtonComponent,FormErrors,FileInput},
    props: ['blog'],
    validations() {
        return {
            blog: {
                title: {
                    required
                },
                excerpt: {
                    required
                },
                content: {
                    required
                },
                image:{
                    required
                }
            },
        }
    },
    setup(props,{emit}){
        const vuelidate = useVuelidate();
        const api = useApi();
        const blog= ref(props.blog)
        const isEdit = blog.value.title!=''
        const notificate = useNotification()
        const image = blog.value.image

        const createBlog = async()=>{
            let validation = await vuelidate.value.$validate();
            // form data
            let fileData = null
            if(image != blog.value.image ){   
                fileData = new FormData()
                fileData.append('file', blog.value.image)
            }
            if(validation){
                let endpoint = null
                if(isEdit){
                    endpoint = api.updateBlog(blog.value,fileData)  
                }else{
                    endpoint = api.addBlog(blog.value,fileData)
                }
                endpoint.then(response=>{
                    console.log(response)
                    notificate.success('Post Blog creado con exito')
                    Inertia.reload()
                    emit('added')
                })
            }else{
                notificate.error('Revisa el formulario')
            }
        }

        return{
            blog,
            createBlog,
            vuelidate
        }
    }
}
</script>

<style>

</style>